import { render, staticRenderFns } from "./SpendChange.vue?vue&type=template&id=be6a565c&scoped=true&"
import script from "./SpendChange.vue?vue&type=script&lang=js&"
export * from "./SpendChange.vue?vue&type=script&lang=js&"
import style0 from "./SpendChange.vue?vue&type=style&index=0&id=be6a565c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6a565c",
  null
  
)

export default component.exports